// Logger wrapper with environment-aware logging
// Use this instead of console.* for better control in production

import { IS_PRODUCTION } from '../config/env'

const shouldLog = !IS_PRODUCTION // Only log in development by default
const shouldDebug = !IS_PRODUCTION // Only debug in development

export const logger = {
  // Basic logging - only in development
  log: (...args: unknown[]) => {
    if (shouldLog) console.log('[LOG]', ...args)
  },
  
  // Warnings - always shown (useful for important warnings)
  warn: (...args: unknown[]) => console.warn('[WARN]', ...args),
  
  // Errors - always shown (critical errors should always be visible)
  error: (...args: unknown[]) => console.error('[ERROR]', ...args),
  
  // Debug - only in development
  debug: (...args: unknown[]) => {
    if (shouldDebug) console.debug('[DEBUG]', ...args)
  },
  
  // Info - similar to log but with INFO prefix
  info: (...args: unknown[]) => {
    if (shouldLog) console.info('[INFO]', ...args)
  },
}

// Optional: export individual functions for convenience
export const log = logger.log
export const warn = logger.warn
export const error = logger.error
export const debug = logger.debug
export const info = logger.info